import React from 'react';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';

import Icon from '../utils/icon';

import { PageTitle } from 'components/pages/pageTitle';
import { callApi } from 'helpers/callApi/callApi';
import { SearchFormContainer } from './searchForm/SearchForm';
import { TableContainer } from './table/Table';
import { ParticipantSearchProps, ParticipantSearchState } from './ParticipantSearch.types';
import styles from './ParticipantSearch.module.scss';
import { FiltersFormContainer } from 'components/eventFilters/EventFilters';
import { ParticipantSearchFilters } from 'components/eventFilters/EventFilters.types';

export class ParticipantSearch extends React.Component<ParticipantSearchProps, ParticipantSearchState> {
  state: ParticipantSearchState = {
    participants: null,
    loading: false,
    error: false,
    showFilters: false,
    searchText: '',
    filters: null,
  };

  componentDidUpdate(prevProps: Readonly<ParticipantSearchProps>, prevState: Readonly<ParticipantSearchState>): void {
    const { fetchParticipantsSearch } = this.props;
    const { searchText, filters } = this.state;

    if (
      searchText.length >= 3 &&
      (prevState.searchText !== searchText || JSON.stringify(prevState.filters) !== JSON.stringify(filters))
    ) {
      callApi({
        action: () => {
          this.setState({ loading: true });

          return fetchParticipantsSearch(searchText, filters?.active, filters?.archived);
        },
        onSuccess: ({ payload }) => this.setState({ participants: payload, loading: false, error: false }),
        onFailure: () => this.setState({ participants: [], loading: false, error: true }),
      });
    }
  }

  onParticipantSearch = (search: string) => {
    this.setState({ searchText: search });
  };

  onFilters = (filters: ParticipantSearchFilters) => {
    this.setState({ filters });
  };

  render() {
    const { participants, loading, error, showFilters } = this.state;

    return (
      <div className={styles.container}>
        <PageTitle displayTitle="Participant search" />
        <div className={styles.toolbar}>
          <SearchFormContainer onSearch={this.onParticipantSearch} />
          <Button
            className={styles.filtersButton}
            color="link"
            onClick={() => this.setState({ showFilters: !showFilters })}
          >
            <Icon icon={faFilter} className={showFilters ? styles.active : styles.inactive} />
          </Button>
          <FiltersFormContainer
            onFilters={this.onFilters}
            className={showFilters ? styles.filtersActive : styles.filtersInactive}
          />
        </div>

        {error ? <div>Something went wrong</div> : <TableContainer participants={participants} loading={loading} />}
      </div>
    );
  }
}
